var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChestRewardGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 284,
    viewBox: "0 0 277 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4504_371662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.501 15L143.721 119.263L188.442 24.9338L153.365 123.257L230.78 53.223L160.746 130.638L259.069 95.5607L164.74 140.282L269.003 145.501L164.74 150.721L259.069 195.442L160.746 160.365L230.78 237.78L153.365 167.746L188.442 266.069L143.721 171.74L138.501 276.003L133.282 171.74L88.5607 266.069L123.638 167.746L46.223 237.78L116.257 160.365L17.9338 195.442L112.263 150.721L8 145.501L112.263 140.282L17.9338 95.5607L116.257 130.638L46.223 53.223L123.638 123.257L88.5607 24.9338L133.282 119.263L138.501 15Z",
    fill: "url(#paint0_radial_4504_371662)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    filter: "url(#filter1_f_4504_371662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.5 54.1025L140.946 126.923L162.156 57.2168L145.671 128.189L184.199 66.3473L149.906 130.635L203.128 80.8719L153.365 134.093L217.652 99.8008L155.811 138.329L226.783 121.844L157.076 143.053L229.897 145.499L157.076 147.945L226.783 169.154L155.811 152.669L217.652 191.197L153.365 156.905L203.128 210.126L149.906 160.364L184.199 224.651L145.671 162.809L162.156 233.781L140.946 164.075L138.5 236.896L136.055 164.075L114.845 233.781L131.33 162.809L92.8022 224.651L127.095 160.364L73.8734 210.126L123.636 156.905L59.3488 191.197L121.19 152.669L50.2183 169.154L119.925 147.945L47.104 145.499L119.925 143.053L50.2183 121.844L121.19 138.329L59.3488 99.8008L123.636 134.093L73.8734 80.8719L127.095 130.635L92.8022 66.3473L131.33 128.189L114.845 57.2168L136.055 126.923L138.5 54.1025Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f_4504_371662)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.315,
    cy: 86.0981,
    r: 36.7319,
    fill: "#FFE016"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_f_4504_371662)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 155.726,
    cy: 150.921,
    r: 64.821,
    fill: "#FFE016"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter4_f_4504_371662)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.583,
    cy: 142.276,
    r: 36.7319,
    fill: "#FFE016"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4504_371662",
    x: 0,
    y: 7,
    width: 277.003,
    height: 277.003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_4504_371662"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4504_371662",
    x: 39.104,
    y: 46.1025,
    width: 198.793,
    height: 198.793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_4504_371662"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4504_371662",
    x: 37.9835,
    y: 0.766212,
    width: 170.664,
    height: 170.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.3,
    result: "effect1_foregroundBlur_4504_371662"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4504_371662",
    x: 42.3053,
    y: 37.4996,
    width: 226.842,
    height: 226.842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.3,
    result: "effect1_foregroundBlur_4504_371662"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4504_371662",
    x: 1.25108,
    y: 56.9439,
    width: 170.664,
    height: 170.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.3,
    result: "effect1_foregroundBlur_4504_371662"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4504_371662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.501 145.501) rotate(89.8422) scale(165.06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestRewardGlow);
export default __webpack_public_path__ + "static/media/chest-reward-glow.dab4a341f11473b6d8c69591c29875ed.svg";
export { ForwardRef as ReactComponent };